import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';

@customElement('visual-solar-activity-level')
export class VisualSolarActivityLevel extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			height: 40%;
			max-height: 220px;
			margin: auto;
			display: flex;
		}
		@media (max-width: 768px) {
			.container {

			}
		}
		.svg {
			height: 100%;
			margin: auto;
			display: block;
			padding-bottom: 20%;
		}

	`;

	render() {
		return html`
			<div class="container">
				<svg-activity-level class="svg"></svg-activity-level>
			</div>
		`;
	}
}
